import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"

export const CardImage = styled.img`
  width: 100%;
  height: auto;
`

export const StyledFlex = styled(Flex)`
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    margin-bottom: ${theme.spacing.three};
  `}
`
